import { keepPreviousData, useQuery } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type { PlatformOwnersListResponse } from '@/types/platform'

export const platformOwnersKey = (
  params: {
    take?: number
    cursor?: string | null
    includeDeleted?: boolean
  } = {}
) => ['platformOwners', params] as const

export const usePlatformOwnersQuery = (params?: {
  take?: number
  cursor?: string | null
  includeDeleted?: boolean
}) => {
  return useQuery({
    queryKey: platformOwnersKey(params ?? {}),
    queryFn: async () => {
      const { data } = await apiClientPlatform.get<PlatformOwnersListResponse>(
        `/platform/owners`,
        {
          params: {
            take: params?.take,
            cursor: params?.cursor ?? undefined,
            includeDeleted: params?.includeDeleted ? 'true' : undefined,
          },
        }
      )
      return data
    },
    placeholderData: keepPreviousData,
  })
}
